<script lang="ts" setup>
  import type { TIcons } from '@/components/icon/types'
  import { cva } from 'class-variance-authority'
  import { useIconStore } from '@/components/icon/store'

  const props = withDefaults(
    defineProps<{
      name: TIcons
      size?: 'xxs' | 'xs' | 'sm' | 'md' | 'ml' | 'lg'
    }>(),
    {
      size: 'md'
    }
  )

  const iconSize = computed(() =>
    cva('', {
      variants: {
        size: {
          xxs: 'text-2xs',
          xs: 'text-xs',
          sm: 'text-base',
          md: 'text-xl',
          ml: 'text-3xl',
          lg: 'text-5xl'
        }
      }
    })({
      size: props.size
    })
  )

  const iconName = computed(() => useIconStore().getIcon(props.name))
</script>

<template>
  <NuxtIcon
    v-if="iconName"
    :name="iconName"
    :class="iconSize"
  />
</template>
